export default [
  {
    path: require(`../assets/r6e_trailer_sch-1080p.webm`),
    id: '1080_webm',
    type: 'video/webm',
    mediaQuery: '(min-width: 1300px)'
  },
  {
    path: require(`../assets/r6e_trailer_sch-720p.webm`),
    id: '720_webm',
    type: 'video/webm',
    mediaQuery: ''
  },
  {
    path: require(`../assets/r6e_trailer_sch-1080p.mp4`),
    id: '1080_mp4',
    type: 'video/mp4',
    mediaQuery: '(min-width: 1300px)'
  },
  {
    path: require(`../assets/r6e_trailer_sch-720p.mp4`),
    id: '720_mp4',
    type: 'video/mp4',
    mediaQuery: ''
  },
];
